import React, { memo } from "react";
import { Link } from "react-router-dom";
import ShowImagePath from "../Others/ImportantFunction";
import { useAuth } from "../../Store/AuthContext";

const DeshBoardFooter = () => {
  const { webSetting } = useAuth();
  // const [webSetting] = WebsiteSetting(RendomTokenfetch);
  // const [ServiceFoot] = FootServices();
  const ImageFooter = ShowImagePath(
    webSetting.file_path,
    webSetting.footer_logo
  );

  const ServiceFoot = [
    "Name Change",
    "Passport Apply",
    "Marriage Certificate",
    "Arya Samaj Marriage",
    "Court Marriage",
  ];
  // console.log(ImageFooter);
  const showfooter = {
    backgroundImage: "url(../images/banner/banner3.webp)",
  };

  return (
    <>
      <footer
        className="main-footer style-two mt-5 mainFooter"
        style={showfooter}
      >
        <div className="footeroverlay"></div>
        <div className="dashboard-outer pt-0">
          <div className="widgets-section">
            <div className="row">
              <div className="big-column col-xl-4 col-lg-3 col-md-12">
                <div className="footer-column about-widget footerLogo_about">
                  <div className="logo">
                    <Link to="https://yourdoorstep.co/">
                      <img
                        src={webSetting.footer_logo && ImageFooter}
                        alt=""
                        style={{ width: "160px" }}
                      />
                    </Link>
                  </div>
                  <p className="footerContenttext">
                    Yourdoorstep, your go-to tech platform that transforms the
                    way you access solution for Home Care, IT Services and
                    Documentation. At Yourdoorstep, we’re committed to
                    revolutionizing the landscape by providing innovative,
                    user-friendly solutions right at your fingertips.
                  </p>
                  {/* <p className="phone-num">
                                <Link to={`tel:${webSetting.mobile_number}`}>
                                  <i className="fa fa-phone"></i> {webSetting.mobile_number}
                                </Link>
                              </p>
                              <p className="address">
                                <i className="fa fa-map-marker"></i>
                                {webSetting.address}
                              </p>
                              <p className="address">
                                <i className="fa fa-envelope"></i>
                                <a href={`mailto: ${webSetting.email}`} className="email">
                                  {webSetting.email}
                                </a>
                              </p> */}

                  <div className="social-links">
                    <Link to={webSetting.facebook}>
                      <i className="fa fa-facebook-f"></i>
                    </Link>
                    <Link to={webSetting.youtube}>
                      <i className="fa fa-youtube"></i>
                    </Link>
                    <Link to={webSetting.twitter}>
                      <i className="fa fa-twitter"></i>
                    </Link>
                    <Link to={webSetting.instagram}>
                      <i className="fa fa-instagram"></i>
                    </Link>
                    <Link to={webSetting.linkedin}>
                      <i className="fa fa-linkedin-in"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="big-column col-xl-8 col-lg-9 col-md-12">
                <div className="row">
                  <div className="footer-column col-lg-4 col-md-6 col-sm-12">
                    <div className="footer-widget links-widget">
                      <h4 className="widget-title">Services</h4>
                      <div className="widget-content">
                        <ul className="list">
                          {ServiceFoot &&
                            ServiceFoot.map((value, index) => (
                              <li key={index}>
                                <Link to="/services">{value}</Link>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="footer-column col-lg-8 col-md-6 col-sm-12">
                    <div className="footer-widget links-widget">
                      <h4 className="widget-title">Quick Links</h4>
                      <div className="widget-content d-flex">
                        <ul className="list">
                          <li>
                            <Link to="/privacy-policy">Privacy & Securty</Link>
                          </li>
                          <li>
                            <Link to="/term-and-condition">
                              Terms of Service
                            </Link>
                          </li>
                          <li>
                            <Link to="/product-service-description">
                              Product Service <br />
                              Description
                            </Link>
                          </li>
                          <li>
                            <Link to="/cancellation-refund-policy">
                              Cancellation Refund Policy
                            </Link>
                          </li>
                          <li>
                            <Link to="/free-advice">Ask Question</Link>
                          </li>
                        </ul>

                        <ul className="list">
                          <li>
                            <Link to="/">Home</Link>
                          </li>
                          <li>
                            <Link to="https://yourdoorstep.co/about">
                              About
                            </Link>
                          </li>
                          <li>
                            <Link to="/services">Services</Link>
                          </li>
                          <li>
                            <Link to="/blog">Blogs</Link>
                          </li>
                          <li>
                            <Link to="https://yourdoorstep.co/contact-us">
                              Contact
                            </Link>
                          </li>
                          <li>
                            <Link to="/payment-methods">Payment Methods</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* <div className="footer-column col-lg-4 col-md-12 col-sm-12">
                    <div className="footer-widget">
                      <h4 className="widget-title">Location</h4>
                      <div className="widget-content">
                        <div className="LocationBox">
                          {webSetting.map_link && (
                            <iframe
                              title="Yourdoorstep Location"
                              src={webSetting.map_link}
                              width="100%"
                              height="220"
                              style={{ border: 0 }}
                              allowFullScreen
                              loading="lazy"
                              referrerPolicy="no-referrer-when-downgrade"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-12">
                <div className="footerWarning">
                  <h5>Disclaimer: </h5>
                  <p>
                    Yourdoorstep is here for people to manage their Home care,
                    Vehicle care, and IT services for managing and designing
                    their websites. We are a solo body and not associated with
                    any government agency or department in any manner. Our motto
                    is to make other’s life easy.{" "}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="auto-container">
            <div className="outer-box">
              <div className="copyright-text">{webSetting.copyright}</div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default memo(DeshBoardFooter);
